import { render, staticRenderFns } from "./ResetPasswordDialog.vue?vue&type=template&id=308b10d2&scoped=true"
import script from "./ResetPasswordDialog.vue?vue&type=script&lang=ts"
export * from "./ResetPasswordDialog.vue?vue&type=script&lang=ts"
import style0 from "./ResetPasswordDialog.vue?vue&type=style&index=0&id=308b10d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "308b10d2",
  null
  
)

export default component.exports